module.exports = __webpack_public_path__ + "img/Citrus_clementina.8d99bbc3.jpg";